import React, { Component } from "react";
import { connect } from "react-redux";

import "./SubmitButton.component.scss";
import { SubmitButtonStrings } from "./SubmitButton.strings";
import { authStoreSelectors } from "../../../../store/store";

export interface SubmitButtonProps {
    form?: any;
    submittingLogin: boolean;
    submittingSignup: boolean;
    submittingRecover: boolean;
    submittingNewPassword: boolean;
}

class SubmitButton extends Component<SubmitButtonProps, {}> {
    render() {
        const { values } = this.props.form;
        let message = SubmitButtonStrings.LOGIN;
        if (values.hasOwnProperty("firstName")) {
            message = SubmitButtonStrings.SIGNUP;
        } else if (
            values.hasOwnProperty("email") &&
            Object.keys(values).length == 1
        ) {
            message = SubmitButtonStrings.RECOVER;
        } else if (
            values.hasOwnProperty("confirmPassword") ||
            values.hasOwnProperty("confirm_password")
        ) {
            message = SubmitButtonStrings.DEFINE;
        }

        return (
            <div id="SubmitButton">
                <button
                    type="submit"
                    className="red-btn"
                    disabled={
                        !this.props.form.isValid ||
                        this.props.submittingLogin ||
                        this.props.submittingSignup ||
                        this.props.submittingRecover ||
                        this.props.submittingNewPassword
                    }
                >
                    {message}
                </button>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    submittingLogin: authStoreSelectors.submittingLogin(state),
    submittingSignup: authStoreSelectors.submittingSignup(state),
    submittingRecover: authStoreSelectors.submittingRecover(state),
    submittingNewPassword: authStoreSelectors.submittingNewPassword(state)
});

export default connect(mapStateToProps, null)(SubmitButton);
